export default __webpack_public_path__ + "static/media/fifa-qna.46082ced.webp";